<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section class="frontmatter-rw Epigraph-rw exclude-auto-rw page-open-right-rw" epub:type="frontmatter epigraph" id="Epigraph1">
<div class="epigraph-rw" id="epigraph1">
<p class="ep1-rw" id="firstpara4"> </p>
<p class="firstpara-rw" id="firstpara5"> </p>
<p class="firstpara-rw" id="firstpara6"> </p>
<p class="firstpara-rw" id="firstpara7"> </p>
<p class="firstpara-rw" id="firstpara8"> </p>
<p class="firstpara-rw" id="p39"><i>“Find what you love, and let it kill you.”</i></p>
<p class="source-rw" id="source11"><i>—Charles Bukowski</i></p>
</div>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// s004-Epigraph-01.vue?591a7d09